import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import { categories, articles } from '@/mocks/siteData';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find(c => c.slug === slug);
  const categoryArticles = articles.filter(a => a.category === slug);

  if (!category) {
    return (
      <main>
        <Navbar />
        <div className="pt-20 min-h-screen flex items-center justify-center px-4">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground-950 mb-3">分类未找到</h1>
            <Link to="/" className="text-sm text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
          </div>
        </div>
        <Footer />
      </main>
    );
  }

  return (
    <>
      <ScrollToTop />
      <main>
        <Navbar />

        <section className="pt-24 pb-6 px-4 md:px-6 bg-background-50">
          <div className="max-w-6xl mx-auto">
            <Breadcrumb items={[
              { label: '首页', to: '/' },
              { label: category.name },
            ]} />
            <div className="mt-6 mb-2">
              <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
                {category.name}
              </h1>
              <p className="text-sm text-foreground-500 mt-2 max-w-2xl">{category.description}</p>
            </div>
          </div>
        </section>

        {/* Category Tabs */}
        <section className="sticky top-16 z-40 bg-background-50/95 backdrop-blur-md border-b border-background-200/70">
          <div className="max-w-6xl mx-auto px-4 md:px-6 py-3 flex items-center gap-2 overflow-x-auto">
            {categories.map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  slug === cat.slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </section>

        {/* Article List */}
        <section className="py-10 px-4 md:px-6 bg-background-50 min-h-[60vh]">
          <div className="max-w-6xl mx-auto">
            {categoryArticles.length > 0 ? (
              <>
                <p className="text-xs text-foreground-400 mb-5">共 {categoryArticles.length} 篇文章</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {categoryArticles.map(article => (
                    <ArticleCard key={article.slug} {...article} />
                  ))}
                </div>
              </>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类暂无文章</p>
              </div>
            )}
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}